export { default } from './text';
export { default as textConfig } from './text.config';
